import { IPeriodAmount } from '@common/models/period-amount';

export interface ISettingsState {
  periodAmounts: IPeriodAmount[];
}

export const initialSettingState: ISettingsState = {
  periodAmounts: null,
};
